import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { TitleWithHint } from './title-with-hint';
import type { IProps } from './models';

export const Title: FC<IProps> = ({
    Caption,
    children,
    hint = '',
    size = 'm',
    styles,
    ...props
}) => {
    const title = (
        <Caption className={cn(styles.external, styles.title)} size={size} theme="white">
            {children}
        </Caption>
    );

    // Заголовок с подсказкой
    if (hint) {
        return (
            <TitleWithHint hint={hint} styles={styles} {...props}>
                {title}
            </TitleWithHint>
        );
    }

    // Заголовок без подсказки
    return title;
};
